import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-sign-in-step-success',
  templateUrl: './sign-in-step-success.component.html',
  styleUrls: ['./sign-in-step-success.component.scss'],
})
export class SignInStepSuccessComponent {
  /** true cuando la cuenta se creó por Google/Facebook: ya está logueada, no requiere verificar email. */
  @Input() isSocialSignup = false;
}
